module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "订单编号"
    },
    model: {
      value: (_vm.filters.orderNO),
      callback: function($$v) {
        _vm.$set(_vm.filters, "orderNO", $$v)
      },
      expression: "filters.orderNO"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "商家ID"
    },
    model: {
      value: (_vm.filters.merchantId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "merchantId", $$v)
      },
      expression: "filters.merchantId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "订单区域"
    },
    model: {
      value: (_vm.filters.provinceIds),
      callback: function($$v) {
        _vm.$set(_vm.filters, "provinceIds", $$v)
      },
      expression: "filters.provinceIds"
    }
  }, _vm._l((_vm.areas), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "工程师ID"
    },
    model: {
      value: (_vm.filters.masterId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "masterId", $$v)
      },
      expression: "filters.masterId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "工程师电话"
    },
    model: {
      value: (_vm.filters.masterPhone),
      callback: function($$v) {
        _vm.$set(_vm.filters, "masterPhone", $$v)
      },
      expression: "filters.masterPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "员工ID"
    },
    model: {
      value: (_vm.filters.workerId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workerId", $$v)
      },
      expression: "filters.workerId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "订单状态"
    },
    model: {
      value: (_vm.filters.state),
      callback: function($$v) {
        _vm.$set(_vm.filters, "state", $$v)
      },
      expression: "filters.state"
    }
  }, _vm._l((_vm.orderType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "商家支付状态"
    },
    model: {
      value: (_vm.filters.merchantPayState),
      callback: function($$v) {
        _vm.$set(_vm.filters, "merchantPayState", $$v)
      },
      expression: "filters.merchantPayState"
    }
  }, _vm._l((_vm.merchantPayStateJSON), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "用户电话"
    },
    model: {
      value: (_vm.filters.userPhone),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userPhone", $$v)
      },
      expression: "filters.userPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "用户姓名"
    },
    model: {
      value: (_vm.filters.userName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userName", $$v)
      },
      expression: "filters.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "用户省份"
    },
    model: {
      value: (_vm.filters.userProvince),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userProvince", $$v)
      },
      expression: "filters.userProvince"
    }
  }, _vm._l((_vm.provinces), function(item) {
    return _c('el-option', {
      key: item.region_id,
      attrs: {
        "label": item.region_name,
        "value": item.region_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "完工码"
    },
    model: {
      value: (_vm.filters.finishCode),
      callback: function($$v) {
        _vm.$set(_vm.filters, "finishCode", $$v)
      },
      expression: "filters.finishCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "车型"
    },
    model: {
      value: (_vm.filters.carType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "carType", $$v)
      },
      expression: "filters.carType"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "picker-options": _vm.pickerOptions,
      "placeholder": "选择日期时间",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getOrders
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出Excel")])], 1), _vm._v(" "), _c('el-form-item', [(_vm.accountType == 2) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.searchMasterWithMap
    }
  }, [_vm._v("安装网点查询")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "highlight-current-row": "",
      "border": "",
      "stripe": "",
      "row-key": _vm.getRowKeys
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 10
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "label-width": "90px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "商家名称"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.merchantName))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "用户姓名"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.userName))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "用户电话"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.userPhone))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "详细地址"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.regionAddress.replace(/,/g, '') + "" + props.row.userAddress))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "车型"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.carType))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "产品信息"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.productInfo))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "技术支持"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.techPhone))])]), _vm._v(" "), (_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "安装费用"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.installMoney)))])]) : _vm._e(), _vm._v(" "), (_vm.accountType == 0) ? _c('el-form-item', {
          attrs: {
            "label": "平台费用"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.platformMoney)))])]) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "补贴费用"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.subsidyMoney)))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "安装备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.installRemark))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.orderRemark.replace(/,/g, '')))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "label-width": "90px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "商城用户ID"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.mallUserId))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "商城订单号"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.mallOrderNO))])]), _vm._v(" "), (_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "商家详情"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryMerchant(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                ")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "付款方式"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatPayType")(props.row.payType)))])]), _vm._v(" "), (_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "补贴备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.subsidyremark))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "label-width": "90px"
          }
        }, [(_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "指派员工"
          }
        }, [(typeof props.row.worker !== 'undefined') ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryCommonUser(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                ")]) : _c('span', [_vm._v("未派单")])], 1) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "工程师详情"
          }
        }, [(typeof props.row.masterId !== 'undefined') ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryMasterUser(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                ")]) : _c('span', [_vm._v("未指派")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "安装时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.installTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "安装图片"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryImage(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                ")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 4
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "label-width": "90px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "商家支付"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMerchantPayState")(props.row.merchantPayState)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单状态"
          }
        }, [(props.row.state == 0) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(props.row.state)))]) : _c('span', {
          staticStyle: {
            "color": "#3398DB"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(props.row.state)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单评分"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.score))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单评价"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.state))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "完工码"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.finishCode))])])], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "orderNO",
      "label": "编号",
      "width": _vm.accountType != 2 ? 100 : ''
    }
  }), _vm._v(" "), (_vm.accountType == 2) ? _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "userName",
      "label": "车主",
      "width": "80"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.accountType == 2) ? _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "userPhone",
      "label": "车主电话",
      "width": "110"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.accountType == 2) ? _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "carType",
      "label": "车型",
      "width": "110"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.accountType == 2) ? _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "productInfo",
      "label": "安装项目",
      "width": "110"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderTime",
      "label": "订单时间",
      "width": 110
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "installTime",
      "label": "结束时间",
      "width": 110
    }
  }), _vm._v(" "), (_vm.accountType != 2) ? _c('el-table-column', {
    attrs: {
      "prop": "merchantId",
      "label": "商家ID",
      "formatter": _vm.formatMerchantId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-table-column', {
    attrs: {
      "prop": "finishCode",
      "label": "完工码",
      "width": "85"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "订单状态",
      "width": "170",
      "formatter": _vm.formatOrderStatus
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [_vm._v("工程师ID: " + _vm._s(scope.row.masterId))]), _vm._v(" "), _c('p', [_vm._v("工程师姓名: " + _vm._s(scope.row.masterName))]), _vm._v(" "), _c('p', [_vm._v("工程师电话: " + _vm._s(scope.row.masterPhone))]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.state == 0) ? _c('el-button', {
          staticStyle: {
            "color": "#f4516c",
            "font-size": "12px"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.assignOnlyID(scope.$index, scope.row)
            }
          }
        }, [_vm._v("指定工程师 | VIP(" + _vm._s(_vm._f("formatVip")(scope.row.vip)) + ")\n                        ")]) : (scope.row.state == -1) ? _c('span', {
          staticStyle: {
            "color": "#3398DB"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(scope.row.state)) + ": " + _vm._s(scope.row.masterId))]) : (scope.row.state == 2) ? _c('span', {
          staticStyle: {
            "color": "#0e0e0e"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(scope.row.state)) + ": " + _vm._s(scope.row.masterId))]) : (scope.row.state == 1) ? _c('el-button', {
          staticStyle: {
            "color": "#34bfa3"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.assignOnlyID(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(scope.row.state)) + ": " + _vm._s(scope.row.masterId) + " | VIP(" + _vm._s(_vm._f("formatVip")(scope.row.vip)) + ")\n                        ")]) : _c('span', {
          staticStyle: {
            "color": "#6673c2"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(scope.row.state)) + ": " + _vm._s(scope.row.masterId))])], 1)])]
      }
    }])
  }), _vm._v(" "), (_vm.accountType != 2) ? _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "workerId",
      "label": "员工ID",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [_vm._v("员工ID: " + _vm._s(scope.row.workerId))]), _vm._v(" "), _c('p', [_vm._v("员工姓名: " + _vm._s(scope.row.workerName))]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('el-tag', [_vm._v(_vm._s(scope.row.workerId))])], 1)])]
      }
    }], null, false, 1866592312)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderMoney",
      "label": "订单费",
      "width": "80",
      "formatter": _vm.formatMoney
    }
  }), _vm._v(" "), (_vm.accountType == 0) ? _c('el-table-column', {
    attrs: {
      "prop": "installMoney",
      "label": "安装费",
      "width": "80",
      "formatter": _vm.formatMoney
    }
  }) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-table-column', {
    attrs: {
      "prop": "subsidyMoney",
      "label": "补贴费",
      "width": "80",
      "formatter": _vm.formatMoney
    }
  }) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-table-column', {
    attrs: {
      "prop": "sumMoney",
      "class-name": "dd",
      "label": "结算费",
      "width": "80",
      "formatter": _vm.formatSumMoney
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "merchantPayState",
      "label": "支付?",
      "width": "80",
      "formatter": _vm.formatMerchantPayState
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "review",
      "label": "回访",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.review == 0) ? _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.review(scope.$index, scope.row)
            }
          }
        }, [_vm._v("未回访\n                ")]) : _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.review(scope.$index, scope.row)
            }
          }
        }, [_vm._v("已回访\n                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": _vm.accountType != 2 ? 210 : ''
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          style: (scope.row.merchantPayState == 1 ? 'color:black' : 'color:#f4516c'),
          attrs: {
            "type": "text",
            "size": "small",
            "disabled": scope.row.merchantPayState == 1
          },
          on: {
            "click": function($event) {
              return _vm.showPayOrderDialog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.merchantPayState == 1 ? '已经支付' : '立即支付') + "\n                ")]), _vm._v(" "), (_vm.accountType != 2) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small",
            "disabled": scope.row.state == 2
          },
          on: {
            "click": function($event) {
              return _vm.assign(scope.$index, scope.row)
            }
          }
        }, [_vm._v("派单\n                ")]) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small",
            "disabled": scope.row.state == 2
          },
          on: {
            "click": function($event) {
              return _vm.showSubsidyDialog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("补贴费用\n                ")]) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small",
            "disabled": scope.row.state == 2
          },
          on: {
            "click": function($event) {
              return _vm.finishOrder(scope.$index, scope.row)
            }
          }
        }, [_vm._v("完成订单\n                ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small",
            "disabled": scope.row.state == 2
          },
          on: {
            "click": function($event) {
              return _vm.showEditOrder(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n                ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showSMSLog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("短信日志\n                ")]), _vm._v(" "), (_vm.accountType != 2) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small",
            "disabled": scope.row.state !== 1
          },
          on: {
            "click": function($event) {
              return _vm.sendSMS(scope.$index, scope.row)
            }
          }
        }, [_vm._v("补发短信\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.state != -1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small",
            "disabled": scope.row.state == 2 || (scope.row.state == 1 && _vm.accountType == 2)
          },
          on: {
            "click": function($event) {
              return _vm.showCancelDialog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("退订\n                ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [(_vm.accountType == 2) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.showBatchPayOrderDialog
    }
  }, [_vm._v("批量支付")]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.rowCount,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑订单",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属商家"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.merchantId + "-" + _vm.editForm.merchantName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "车辆型号",
      "prop": "carTypeIds"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.carType))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "产品",
      "prop": "productTypes"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.productInfo))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "订单费用"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "palevioletred"
    }
  }, [_vm._v(_vm._s(_vm.editForm.orderMoney) + "元")])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "用户姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "userName", $$v)
      },
      expression: "editForm.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "手机号码"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.userPhone),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "userPhone", $$v)
      },
      expression: "editForm.userPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "地区"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "不选择则使用之前地区",
      "options": _vm.addProvinces,
      "props": _vm.props
    },
    on: {
      "active-item-change": _vm.select_ChangeEvent
    },
    model: {
      value: (_vm.regionId),
      callback: function($$v) {
        _vm.regionId = $$v
      },
      expression: "regionId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "详细地址"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.userAddress),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "userAddress", $$v)
      },
      expression: "editForm.userAddress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商城ID"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.mallUserId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mallUserId", $$v)
      },
      expression: "editForm.mallUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商城订单号"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.mallOrderNO),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mallOrderNO", $$v)
      },
      expression: "editForm.mallOrderNO"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物流信息"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.logistics),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "logistics", $$v)
      },
      expression: "editForm.logistics"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.orderRemark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "orderRemark", $$v)
      },
      expression: "editForm.orderRemark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "安装备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.installRemark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "installRemark", $$v)
      },
      expression: "editForm.installRemark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增订单",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeDialog
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px"
    }
  }, [(_vm.accountType == 1 || _vm.accountType == 0) ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "所属商家"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择商家"
    },
    on: {
      "change": _vm.getProducts
    },
    model: {
      value: (_vm.addForm.merchantId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "merchantId", $$v)
      },
      expression: "addForm.merchantId"
    }
  }, _vm._l((_vm.merchant), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.userId + ' - ' + item.name,
        "value": item.userId
      }
    })
  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "车辆品牌",
      "prop": "carBrandId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择车辆品牌"
    },
    on: {
      "change": _vm.getCarTypes
    },
    model: {
      value: (_vm.carBrandId),
      callback: function($$v) {
        _vm.carBrandId = $$v
      },
      expression: "carBrandId"
    }
  }, _vm._l((_vm.carBrands), function(item) {
    return _c('el-option', {
      key: item.carBrandId,
      attrs: {
        "label": item.brandName,
        "value": item.carBrandId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "车辆型号",
      "prop": "carTypeId"
    }
  }, [_c('el-select', {
    staticClass: "el-select__input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择车辆类型"
    },
    on: {
      "change": _vm.getProductPrice
    },
    model: {
      value: (_vm.addForm.carTypeId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "carTypeId", $$v)
      },
      expression: "addForm.carTypeId"
    }
  }, _vm._l((_vm.carTypes), function(item) {
    return _c('el-option', {
      key: item.carTypeId,
      attrs: {
        "label": item.carTypeName,
        "value": item.carTypeId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "产品",
      "prop": "productType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择产品"
    },
    on: {
      "change": _vm.getProductPrice
    },
    model: {
      value: (_vm.addForm.productId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "productId", $$v)
      },
      expression: "addForm.productId"
    }
  }, _vm._l((_vm.products), function(item) {
    return _c('el-option', {
      key: item.productId,
      attrs: {
        "label": item.productName,
        "value": item.productId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单费用"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "palevioletred"
    }
  }, [_vm._v(_vm._s(_vm.orderMoney) + "元")])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "用户姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userName", $$v)
      },
      expression: "addForm.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "手机号码"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.userPhone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userPhone", $$v)
      },
      expression: "addForm.userPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "地区"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "medium",
      "placeholder": "地区",
      "options": _vm.addProvinces,
      "props": _vm.props
    },
    on: {
      "active-item-change": _vm.select_ChangeEvent
    },
    model: {
      value: (_vm.regionId),
      callback: function($$v) {
        _vm.regionId = $$v
      },
      expression: "regionId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "详细地址"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.userAddress),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userAddress", $$v)
      },
      expression: "addForm.userAddress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商城ID"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.mallUserId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mallUserId", $$v)
      },
      expression: "addForm.mallUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商城订单号"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.mallOrderNO),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mallOrderNO", $$v)
      },
      expression: "addForm.mallOrderNO"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物流信息"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.logistics),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "logistics", $$v)
      },
      expression: "addForm.logistics"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.orderRemark),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "orderRemark", $$v)
      },
      expression: "addForm.orderRemark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "安装备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.installRemark),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "installRemark", $$v)
      },
      expression: "addForm.installRemark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看图片",
      "close-on-click-modal": false,
      "customClass": "customWidth"
    },
    model: {
      value: (_vm.queryImageVisible),
      callback: function($$v) {
        _vm.queryImageVisible = $$v
      },
      expression: "queryImageVisible"
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "门头相片"
    }
  }, _vm._l((_vm.images), function(item) {
    return _c('img', {
      attrs: {
        "src": item
      }
    })
  }), 0)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "派单",
      "customClass": "assignWidth",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.assignFormVisible),
      callback: function($$v) {
        _vm.assignFormVisible = $$v
      },
      expression: "assignFormVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.assignForm,
      "label-width": "120px"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.assignFilters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "输入地区搜索,不输入则搜索默认地址"
    },
    model: {
      value: (_vm.assignFilters.address),
      callback: function($$v) {
        _vm.$set(_vm.assignFilters, "address", $$v)
      },
      expression: "assignFilters.address"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getPoi()
      }
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#f4516c",
      "font-size": "16px"
    }
  }, [_vm._v("已指派工程师:" + _vm._s(_vm.assignForm.masterId == '' ? '还未指派' : _vm.assignForm.masterId))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "map",
    attrs: {
      "id": "container"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.masterUsers,
      "highlight-current-row": "",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "付款账号"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.logistics))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "营业时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.workTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "服务类型"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatServiceType")(props.row.serviceType)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.remark))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片详情"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryImage(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                        ")])], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "经营主体"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.storeInfo))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "技能标签"
          }
        }, [_c('span', [_vm._v(_vm._s(("" + (typeof props.row.skills=='undefined'?'':props.row.skillsDesc))))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "等级-积分"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatLevel")(props.row.level)) + "-" + _vm._s(props.row.score))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "面试方式"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatInterview")(props.row.interviewType)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "邀请码"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.recommendCode))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "详细地址"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.address))])])], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "masterId",
      "label": "工程师ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "等级",
      "width": "120",
      "formatter": _vm.formatLevel
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastLoginTime",
      "label": "是否关注",
      "width": "120",
      "formatter": _vm.formatLastLoginTime
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storeName",
      "label": "店铺名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distance",
      "label": "距离",
      "width": "110",
      "formatter": _vm.formatDistance
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号码",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "详细地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.regionAddress.replace(/,/g, '') + "" + scope.row.address))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderCount",
      "label": "订单量",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "info",
            "size": "small",
            "disabled": scope.row.orderCount == 0
          },
          on: {
            "click": function($event) {
              return _vm.masterDetailOrder(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看:" + _vm._s(scope.row.orderCount) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.confirmAssignSubmit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n                            确认指派\n                        ")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "订单详情",
      "customClass": "assignWidth",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.masterDetailOrderVisible),
      callback: function($$v) {
        _vm.masterDetailOrderVisible = $$v
      },
      expression: "masterDetailOrderVisible"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.masterDetailOrders,
      "highlight-current-row": "",
      "border": "",
      "stripe": "",
      "row-key": _vm.getRowKeys
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "label-width": "120px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "商城用户ID"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.mallUserId))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "商城订单号"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.mallOrderNO))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "用户姓名"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.userName))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "用户电话"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.userPhone))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "详细地址"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.regionAddress.replace(/,/g, '') + "" + props.row.userAddress))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "付款方式"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatPayType")(props.row.payType)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "物流信息"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.logistics))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.orderRemark))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [(_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "指派员工"
          }
        }, [(typeof props.row.worker !== 'undefined') ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryCommonUser(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                    ")]) : _c('span', [_vm._v("未派单")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "安装时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.installTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "安装备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.productInfo))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "安装图片"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryImage(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                    ")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "车型"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.carType))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "产品信息"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.productInfo))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单费用"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.orderMoney)))])]), _vm._v(" "), (_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "安装费用"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.installMoney)))])]) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "平台费用"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.platformMoney)))])]) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "补贴费用"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.subsidyMoney)))])]) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-form-item', {
          attrs: {
            "label": "补贴备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.subsidyremark))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 4
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "商家支付"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMerchantPayState")(props.row.merchantPayState)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单状态"
          }
        }, [(props.row.state == 0) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(props.row.state)))]) : _c('span', {
          staticStyle: {
            "color": "#3398DB"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(props.row.state)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单评分"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.score))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单评价"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.state))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "完工码"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.finishCode))])])], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "orderNO",
      "label": "订单编号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderTime",
      "label": "订单时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "merchantId",
      "label": "商家ID",
      "formatter": _vm.formatMerchantId
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "订单状态",
      "width": "100",
      "formatter": _vm.formatOrderStatus
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [_vm._v("工程师ID: " + _vm._s(scope.row.masterId))]), _vm._v(" "), _c('p', [_vm._v("工程师姓名: " + _vm._s(scope.row.masterName))]), _vm._v(" "), _c('p', [_vm._v("工程师电话: " + _vm._s(scope.row.masterPhone))]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.state == 0) ? _c('span', {
          staticStyle: {
            "color": "#f4516c"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(scope.row.state)) + ":" + _vm._s(scope.row.workerId))]) : (scope.row.state == -1) ? _c('span', {
          staticStyle: {
            "color": "#3398DB"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(scope.row.state)) + ":" + _vm._s(scope.row.workerId))]) : (scope.row.state == 2) ? _c('span', {
          staticStyle: {
            "color": "#0e0e0e"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(scope.row.state)) + ":" + _vm._s(scope.row.workerId))]) : (scope.row.state == 1) ? _c('span', {
          staticStyle: {
            "color": "#34bfa3"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(scope.row.state)) + ":" + _vm._s(scope.row.workerId))]) : _c('span', {
          staticStyle: {
            "color": "#6673c2"
          }
        }, [_vm._v(_vm._s(_vm._f("formatOrderStatus")(scope.row.state)) + ":" + _vm._s(scope.row.workerId))])])])]
      }
    }])
  }), _vm._v(" "), (_vm.accountType != 2) ? _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "workerId",
      "label": "员工ID",
      "width": "80"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productInfo",
      "label": "产品信息",
      "width": "120"
    }
  }), _vm._v(" "), (_vm.accountType != 2) ? _c('el-table-column', {
    attrs: {
      "prop": "installMoney",
      "label": "安装费",
      "width": "80",
      "formatter": _vm.formatMoney
    }
  }) : _vm._e(), _vm._v(" "), (_vm.accountType != 2) ? _c('el-table-column', {
    attrs: {
      "prop": "subsidyMoney",
      "label": "补贴费",
      "width": "80",
      "formatter": _vm.formatMoney
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "prop": "merchantPayState",
      "label": "支付状态",
      "width": "100",
      "formatter": _vm.formatMerchantPayState
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "review",
      "label": "回访",
      "width": "100",
      "formatter": _vm.formatMoney
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.review == 0) ? _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.review(scope.$index, scope.row)
            }
          }
        }, [_vm._v("未回访\n                    ")]) : _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.review(scope.$index, scope.row)
            }
          }
        }, [_vm._v("已回访\n                    ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认派单",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.confirmAssignVisible),
      callback: function($$v) {
        _vm.confirmAssignVisible = $$v
      },
      expression: "confirmAssignVisible"
    }
  }, [_c('el-form', {
    ref: "confirmAssignForm",
    attrs: {
      "model": _vm.confirmAssignForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "安装费用"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入安装费用",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.confirmAssignForm.installMoney),
      callback: function($$v) {
        _vm.$set(_vm.confirmAssignForm, "installMoney", $$v)
      },
      expression: "confirmAssignForm.installMoney"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.confirmAssignVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirmAssignSubmit($event)
      }
    }
  }, [_vm._v("更新\n            ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "补贴费用",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.subsidyVisible),
      callback: function($$v) {
        _vm.subsidyVisible = $$v
      },
      expression: "subsidyVisible"
    }
  }, [_c('el-form', {
    ref: "subsidyForm",
    attrs: {
      "model": _vm.subsidyForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "补贴费用",
      "prop": "subsidyMoney"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入补贴费用",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.subsidyForm.subsidyMoney),
      callback: function($$v) {
        _vm.$set(_vm.subsidyForm, "subsidyMoney", $$v)
      },
      expression: "subsidyForm.subsidyMoney"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "备注",
      "prop": "subsidyRemark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入备注",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.subsidyForm.subsidyRemark),
      callback: function($$v) {
        _vm.$set(_vm.subsidyForm, "subsidyRemark", $$v)
      },
      expression: "subsidyForm.subsidyRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.subsidyVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.subsidySubmit($event)
      }
    }
  }, [_vm._v("提交\n            ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "指定工程师",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.assignIDVisible),
      callback: function($$v) {
        _vm.assignIDVisible = $$v
      },
      expression: "assignIDVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.assignIDForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "工程师ID",
      "prop": "masterId"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "输入工程师ID",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.assignIDForm.masterId),
      callback: function($$v) {
        _vm.$set(_vm.assignIDForm, "masterId", $$v)
      },
      expression: "assignIDForm.masterId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.assignIDVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.assignIDSubmit($event)
      }
    }
  }, [_vm._v("提交\n            ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "订单退订",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.cancelOrderVisible),
      callback: function($$v) {
        _vm.cancelOrderVisible = $$v
      },
      expression: "cancelOrderVisible"
    }
  }, [_c('el-form', {
    ref: "cancelOrderForm",
    attrs: {
      "model": _vm.cancelOrderForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "备注",
      "prop": "cancelOrderRemark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入备注",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.cancelOrderForm.cancelRemark),
      callback: function($$v) {
        _vm.$set(_vm.cancelOrderForm, "cancelRemark", $$v)
      },
      expression: "cancelOrderForm.cancelRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.cancelOrderVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelOrderSubmit($event)
      }
    }
  }, [_vm._v("提交\n            ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "回访",
      "customClass": "customWidth",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.reviewVisible),
      callback: function($$v) {
        _vm.reviewVisible = $$v
      },
      expression: "reviewVisible"
    }
  }, [(_vm.accountType != 2) ? _c('el-form', {
    ref: "reviewForm",
    attrs: {
      "model": _vm.reviewForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "回访内容",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入回访内容",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.reviewForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.reviewForm, "remark", $$v)
      },
      expression: "reviewForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "是否保密",
      "prop": "isPublic"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-color": "#13ce66",
      "on-text": "公开",
      "off-text": "保密",
      "off-color": "#ff4949"
    },
    model: {
      value: (_vm.reviewForm.isPublic),
      callback: function($$v) {
        _vm.$set(_vm.reviewForm, "isPublic", $$v)
      },
      expression: "reviewForm.isPublic"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.reviews,
      "highlight-current-row": "",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userId",
      "label": "操作用户ID",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "用户姓名",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewTime",
      "label": "时间",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "内容",
      "min-width": "100"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.reviewVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.accountType != 2) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reviewSubmit($event)
      }
    }
  }, [_vm._v("提交\n            ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "支付订单",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.payOrderVisible),
      callback: function($$v) {
        _vm.payOrderVisible = $$v
      },
      expression: "payOrderVisible"
    }
  }, [_c('el-form', {
    ref: "payOrderForm",
    attrs: {
      "model": _vm.payOrderForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "订单编号"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "按一竖列输入订单编号",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.payOrderForm.orderNOs),
      callback: function($$v) {
        _vm.$set(_vm.payOrderForm, "orderNOs", $$v)
      },
      expression: "payOrderForm.orderNOs"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.payOrderForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.payOrderForm, "remark", $$v)
      },
      expression: "payOrderForm.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.payOrderVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.payOrderSubmit($event)
      }
    }
  }, [_vm._v("立即支付\n            ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "短信日志",
      "close-on-click-modal": false,
      "customClass": "customWidth"
    },
    model: {
      value: (_vm.SMSLogVisible),
      callback: function($$v) {
        _vm.SMSLogVisible = $$v
      },
      expression: "SMSLogVisible"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    attrs: {
      "data": _vm.smsLogDatas,
      "highlight-current-row": "",
      "border": "",
      "stripe": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNO",
      "label": "订单编号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "masterPhone",
      "label": "工程师电话",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "masterName",
      "label": "工程师姓名",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-align": "left",
      "color": "red"
    },
    attrs: {
      "prop": "smsContent",
      "label": "内容",
      "min-width": "205"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "搜索工程师",
      "customClass": "assignWidth",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.searchMasterWithMapVisible),
      callback: function($$v) {
        _vm.searchMasterWithMapVisible = $$v
      },
      expression: "searchMasterWithMapVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.searchMasterWithMapFilters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "输入详细市名+地址搜索"
    },
    model: {
      value: (_vm.searchMasterWithMapFilters.address),
      callback: function($$v) {
        _vm.$set(_vm.searchMasterWithMapFilters, "address", $$v)
      },
      expression: "searchMasterWithMapFilters.address"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getPoi_searchMasterWithMap()
      }
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "map",
    attrs: {
      "id": "container_searchMasterWithMap"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.masterUsers_searchMasterWithMap,
      "highlight-current-row": "",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "付款账号"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.logistics))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "营业时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.workTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "服务类型"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatServiceType")(props.row.serviceType)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.remark))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片详情"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryImage(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                        ")])], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "经营主体"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.storeInfo))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "技能标签"
          }
        }, [_c('span', [_vm._v(_vm._s(("" + (typeof props.row.skills=='undefined'?'':props.row.skillsDesc))))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "等级-积分"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatLevel")(props.row.level)) + "-" + _vm._s(props.row.score))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "面试方式"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatInterview")(props.row.interviewType)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "邀请码"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.recommendCode))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "详细地址"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.address))])])], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "masterId",
      "label": "工程师ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "等级",
      "width": "120",
      "formatter": _vm.formatLevel
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storeName",
      "label": "店铺名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distance",
      "label": "距离",
      "width": "110",
      "formatter": _vm.formatDistance
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "详细地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.regionAddress.replace(/,/g, '') + "" + scope.row.address))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('form', {
    ref: "exportEx",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "method": "post",
      "target": "_blank"
    }
  }, [_c('input', {
    ref: "token",
    attrs: {
      "type": "text",
      "name": "token"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6274b0e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/installOrder.vue
// module id = 1087
// module chunks = 1